module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-right-bottom-stone-path-background-remnants.39f66d62.png";